import React, {useEffect} from "react";
import {Grid, IconButton, Typography} from "@material-ui/core";
import {ArrowBack} from "@material-ui/icons";
import {useGlobalStyles} from "../../../utils/styles";
import {useStyles} from "./taxonomy";
import {PocChannelProperties} from "../../../../settings/default_properties";
import {getAttributes as utilGetAttributes, utilGetPartners, utilSearchLastImport} from "../../../utils/utils";
import EnhancedErrorDialog from "../../../components/EnhancedErrorDialog";
import ChannelModifier from "../components/channel_modifier";
import EnhancedCircularLoader from "../../../components/EnhancedCircularLoader";
import {loadProfiles} from "../../../../files/import_export_profiles";
import {formatProfileFromRemote} from "../../import/product/advanced_supplier_import";

export default function ChannelSettings(props) {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    const [error, setError] = React.useState({open: false, errorHeader: "", errorMessage: ""});
    const [attributes, setAttributes] = React.useState([]);
    const [groupedAttributes, setGroupedAttributes] = React.useState({});
    const [partners, setPartners] = React.useState([]);
    const [profiles, setProfiles] = React.useState(undefined);
    const [lastImports, setLastImports] = React.useState(undefined);

    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const loadPartners = async () => {
            let partners = await utilGetPartners();
            if (partners.errorMessage) return;

            let sortedPartners = partners.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName));
            setPartners(sortedPartners);
        }

        const getAttributes = async () => {
            const marketplaceRetailers = props.retailers.filter(retailer => retailer.Marketplace === true);

            const channelAttributes = marketplaceRetailers.map(retailer => async () => {
                return await utilGetAttributes(retailer.Id, false);
            });

            let groupedAttributes = {};
            let attributes = await Promise.all(channelAttributes.map(async (attribute) => await attribute()));
            attributes = attributes.map((attribute, index) => {
                groupedAttributes[marketplaceRetailers[index].Id] = attribute;
                return attribute;
            });

            attributes = attributes.flat().filter((attribute, index, self) =>
                index === self.findIndex((t) => (
                    t.Name === attribute.Name
                ))
            );

            if (attributes.length === 0) {
                setError({
                    open: true,
                    errorHeader: "Error",
                    errorMessage: "Failed to load attributes"
                });
            } else {
                setGroupedAttributes(groupedAttributes);
                setAttributes(attributes);
            }
        }

        const loadImportProfiles = async () => {
            let profiles = await loadProfiles("ImportCatalogItems");
            setProfiles(profiles.map(profile => formatProfileFromRemote(profile)));
        }

        const loadImports = async () => {
            const importsByChannel = {};
            const channels = props.retailers.filter(retailer => retailer.Marketplace === true);
            const lastImports = await Promise.all(channels.map(async (channel) => {
                return await utilSearchLastImport(channel.Id);
            }));

            channels.forEach((channel, index) => {
                if(lastImports[index].success) {
                    let records = lastImports[index].data;
                    if(records.length > 0) {
                        importsByChannel[channel.Id] = records[0];
                    }
                }
            });

            setLastImports(importsByChannel);
        }

        const init = async () => {
            setLoading(true);
            await loadPartners();
            await getAttributes();
            await loadImportProfiles();
            await loadImports();
            setLoading(false);
        }

        init();

        // eslint-disable-next-line
    }, []);

    return (
        <Grid container className={classes.root}
              style={{gap: "24px", padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justify={"space-between"} direction={"row"}>
                <Grid item container xs={6} justify={"flex-start"} alignItems={"center"} style={{gap: "12px"}}>
                    <IconButton className={globalClasses.iconButton}
                                style={{height: "36px", width: "36px"}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (props.location.key === undefined)
                                        props.history.push("/productonboardingcenter/catalog");
                                    else
                                        props.history.goBack();
                                }}>
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>

                    <Typography className={classes.header}>
                        Channel Settings
                    </Typography>
                </Grid>
            </Grid>

            {loading ? (
                <Grid container style={{width: "100%", height: "100%", justifyContent: "center", alignItems: "center"}}>
                    <EnhancedCircularLoader />
                </Grid>
            ) : (
                <>
                    <PocChannelProperties
                        options={attributes}
                        template={(templateProps) => {
                            return (
                                <ChannelModifier
                                    partners={partners}
                                    attributes={attributes}
                                    groupedAttributes={groupedAttributes}
                                    retailers={props.retailers}
                                    profiles={profiles}
                                    lastImports={lastImports}

                                    {...templateProps}
                                />
                            );
                        }}
                    />
                </>
            )}

            <EnhancedErrorDialog open={error.open} onClose={() => setError({...error, open: false})}
                                 errorHeader={error.errorHeader} errorMessage={error.errorMessage}/>
        </Grid>
    )
}
